import { useEffect } from 'react'
import Stats from 'stats.js'
import { useFpsQuery } from '@/src/hooks/useFpsQuery'

const STATS_OPACITY = '0.5'
const STATS_Z_INDEX = '2147483647'

/**
 * Mounts a stats.js panel (FPS / MS / MB) when `?fps` is present in the URL.
 * Click the panel to cycle metrics. Opacity is fixed at 50%.
 */
export function StatsOverlay() {
    const { isEnabled } = useFpsQuery()

    useEffect(() => {
        if (!isEnabled) {
            return
        }

        const stats = new Stats()
        stats.showPanel(0)
        stats.dom.style.opacity = STATS_OPACITY
        stats.dom.style.zIndex = STATS_Z_INDEX
        stats.dom.style.pointerEvents = 'auto'
        document.body.appendChild(stats.dom)

        let frameId = 0
        const tick = () => {
            stats.update()
            frameId = requestAnimationFrame(tick)
        }
        frameId = requestAnimationFrame(tick)

        return () => {
            cancelAnimationFrame(frameId)
            stats.dom.remove()
        }
    }, [isEnabled])

    return null
}
